import React from 'react';
import { CheckCircle, X } from 'lucide-react';
import { coverOf, fmtPrice, fmtKm } from './inventoryUtils';

export const vehicleLabel = (v, en) => {
  const price = fmtPrice(v.price, en);
  return `${v.year} ${v.make} ${v.model}${v.trim ? ` ${v.trim}` : ''}${v.stock_number ? ` (Stock ${v.stock_number})` : ''}${price ? ` - ${price}` : ''}`;
};

export const SelectedVehicleCard = ({ v, en, onRemove, compact }) => (
  <div className={`flex items-center bg-green-50 border-2 border-[#1a5c3b]/30 rounded-xl animate-fade-up ${compact ? 'gap-3 p-2.5 mb-4' : 'gap-4 p-3 mb-6'}`} data-testid="selected-vehicle-card">
    <img src={coverOf(v)} alt="" className={`object-cover rounded-lg shrink-0 ${compact ? 'w-20 h-14' : 'w-24 h-16 sm:w-28 sm:h-20'}`} />
    <div className="flex-1 min-w-0">
      <p className="flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wider text-[#1a5c3b]">
        <CheckCircle className="w-3.5 h-3.5" />{en ? 'Selected vehicle' : 'Véhicule choisi'}
      </p>
      <p className={`font-bold text-slate-900 truncate ${compact ? 'text-sm' : ''}`} data-testid="selected-vehicle-title">{v.year} {v.make} {v.model} {v.trim || ''}</p>
      <p className={`text-slate-500 ${compact ? 'text-xs' : 'text-sm'}`}>
        {fmtPrice(v.price, en) && <span className="font-bold text-[#1a5c3b] mr-2">*{fmtPrice(v.price, en)}</span>}
        {fmtKm(v.mileage, en)}{v.stock_number ? ` • Stock ${v.stock_number}` : ''}
      </p>
    </div>
    <button type="button" onClick={onRemove} className="p-2 rounded-full hover:bg-white text-slate-400 hover:text-slate-700 transition-colors" aria-label="Remove" data-testid="selected-vehicle-remove">
      <X className="w-4 h-4" />
    </button>
  </div>
);
